import { render, staticRenderFns } from "./LayoutGeoNovation.vue?vue&type=template&id=37b88cd7&"
import script from "./LayoutGeoNovation.vue?vue&type=script&lang=js&"
export * from "./LayoutGeoNovation.vue?vue&type=script&lang=js&"
import style0 from "./LayoutGeoNovation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports